import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { AuthGate } from "@/knowmeno/AuthGate";
import { ProfileSync } from "@/knowmeno/ProfileSync";
import { installStorageShim } from "@/knowmeno/storageShim";
import KnowMenoApp from "@/knowmeno/KnowMenoApp";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/app")({
  head: () => ({
    meta: [
      { title: "Your Dashboard — KnowMeno" },
      {
        name: "description",
        content:
          "Track your symptoms, mood, cycle, and HRT — and build an ongoing report your doctor will actually use.",
      },
      { property: "og:title", content: "Your Dashboard — KnowMeno" },
      {
        property: "og:description",
        content:
          "Track your symptoms, mood, cycle, and HRT — and build an ongoing report your doctor will actually use.",
      },
      { property: "og:url", content: "https://www.knowmeno.com/app" },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: "https://www.knowmeno.com/app" }],
  }),
  component: AppPage,
});

function AppPage() {
  const [shimReady, setShimReady] = useState(false);
  useEffect(() => {
    installStorageShim();
    setShimReady(true);
  }, []);

  if (!shimReady) return null;

  return (
    <div style={{ background: "#FAF7F5", minHeight: "100vh", padding: "0 16px" }}>
      <AuthGate>
        {(session) => (
          <ProfileSync session={session}>
            <KnowMenoApp
              sessionEmail={session.user.email ?? ""}
              signOut={async () => {
                await supabase.auth.signOut();
              }}
            />
          </ProfileSync>
        )}
      </AuthGate>
    </div>
  );
}
